import { formatNumber } from '../ui';

export function normalizeUnitPrice(value) {
  if (value == null || value === '') return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

export function computeLineTotal(quantity, unitPrice) {
  const qty = Number(quantity || 0);
  const price = normalizeUnitPrice(unitPrice);
  if (!price || qty <= 0) return null;
  return price * qty;
}

export function summarizeDispensationPricing(items = []) {
  let total = 0;
  let pricedLines = 0;
  let unpricedLines = 0;

  const enriched = items.map((item) => {
    const price = normalizeUnitPrice(item.price);
    const lineTotal = computeLineTotal(item.quantity, price);
    if (lineTotal != null) {
      total += lineTotal;
      pricedLines += 1;
    } else {
      unpricedLines += 1;
    }
    return { ...item, price, line_total: lineTotal };
  });

  return {
    items: enriched,
    pricing: {
      total,
      priced_lines: pricedLines,
      unpriced_lines: unpricedLines,
      complete: unpricedLines === 0 && enriched.length > 0
    }
  };
}

export function formatPharmacyPrice(value) {
  const price = normalizeUnitPrice(value);
  if (price == null) return null;
  return `${formatNumber(price)} Ar`;
}

export function formatPharmacyLineTotal(value) {
  const total = value == null ? null : Number(value);
  if (!Number.isFinite(total)) return '—';
  return `${formatNumber(total)} Ar`;
}
